export const UPDATE_TICKETS_FILTERS = "UPDATE_TICKETS_FILTERS";
export const SAVE_AUTH_TICKET__INFO = "SAVE_AUTH_TICKET__INFO";
export const RESET_TICKETS_PAGINATION_FILTERS = "RESET_TICKETS_PAGINATION_FILTERS";
export const SET_TICKETS_LOADING = "SET_TICKETS_LOADING";
export const SET_TICKETS_META = "SET_TICKETS_META";
export const SET_TICKETS_PAGINATION_CURSOR = "SET_TICKETS_PAGINATION_CURSOR";
